export enum NewOptionActionTypes {
  PRODUCT_NEW_OPTION_REQUEST = 'PRODUCT_NEW_OPTION_REQUEST',
  PRODUCT_NEW_OPTION_SUCCESS = 'PRODUCT_NEW_OPTION_SUCCESS',
  PRODUCT_NEW_OPTION_FAILURE = 'PRODUCT_NEW_OPTION_FAILURE',
  ITEM_SELECTED = 'ITEM_SELECTED',
  ITEMS_MERGED = 'ITEMS_MERGED',
  ITEMS_SELECTED = 'ITEMS_SELECTED',
  GROUP_ACTIVATED = 'GROUP_ACTIVATED',
}
